import { homePageTitle, servicesPageTitle as staticServicesTitle } from "./pageMetadata";

type PageContextWithProps = {
  pageProps?: {
    initialService?: any;
    initialWorker?: any;
  };
  urlPathname?: string;
};

export function servicePageTitle(pageContext: PageContextWithProps): string {
  const service = pageContext.pageProps?.initialService;
  const name =
    service?.mlname?.es ||
    service?.mlname?.en ||
    service?.name;
  return name ? `${name} | Jandi` : "Jandi";
}

export function workerPageTitle(pageContext: PageContextWithProps): string {
  const worker = pageContext.pageProps?.initialWorker;
  const user = worker?.user;
  const name =
    user?.fullName ||
    [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim();
  return name ? `${name} | Jandi` : "Jandi";
}

export function servicesPageTitle(): string {
  return staticServicesTitle();
}

export function homePageTitleFromConfig(): string {
  return homePageTitle();
}
